module.exports = __webpack_public_path__ + "static/media/yuli.4236d299.jpg";